/* eslint-disable import/order */
import jwtDecode, { JwtPayload } from 'jwt-decode';

import axios from 'axios';

type MetadataType =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | Record<
      string,
      string | number | boolean | string[] | number[] | Record<string, string | number | boolean | string[] | number[]>
    >;

interface Metadata {
  [x: string]: MetadataType;
}

interface handleHqOTrackingFunction {
  (clientApiUrl: string, authToken: string, eventType: string, metadata: Metadata): void;
}

interface HqOJwtPayload extends JwtPayload {
  user_uuid: string;
}

export const handleHqOTracking: handleHqOTrackingFunction = (clientApiUrl, authToken, eventType, metadata) => {
  const { building_uuid, app_uuid, user_agent, type, timestamp, ...rest } = metadata;
  const { user_uuid } = jwtDecode<HqOJwtPayload>(authToken);
  axios.post(
    `${clientApiUrl}/api/analytics/v2/tracking/track`,
    {
      type,
      eventType,
      timestamp,
      userUuid: user_uuid,
      appUuid: app_uuid,
      buildingUuid: building_uuid,
      userAgent: user_agent,
      properties: {
        ...rest,
      },
    },
    {
      headers: {
        // @ts-expect-error: axios doesn't like our custom header keys
        'hqo-building-uuid': building_uuid,
        // @ts-expect-error: axios doesn't like our custom header keys
        'hqo-app-id': app_uuid,
        'Authorization': `${authToken}`,
      },
    },
  );
};

export interface hqoMetadata {
  type: 'action' | 'impression';
  [x: string]: MetadataType;
}

export const validateMetadata = (metadata: hqoMetadata) => {
  const requiredFields = ['building_uuid', 'app_uuid', 'user_agent', 'type'];
  let isValid = true;

  requiredFields.forEach((field) => {
    if (!metadata[field]) {
      console.warn(`Missing the following field in metadata: "${field}"`);
      isValid = false;
    }

    if (field === 'type') {
      const eventTypes = ['action', 'impression'];
      if (!eventTypes.includes(metadata.type)) {
        console.warn(`Event type must be "action" or "impression". Invalid type: "${metadata.type}"`);
        isValid = false;
      }
    }
  });

  return isValid;
};
